import { AlkLogger } from '@alk/core';
import { comApiVersion } from '../../constants';
export class OpenfinChannelProvider {
    constructor() {
        this.create = async (channelLabel) => {
            this.channel = await fin.InterApplicationBus.Channel.create(channelLabel);
            this.channelLabel = channelLabel;
            return this;
        };
        this.disconnect = async () => {
            await this.channel.destroy();
        };
        this.dispatch = async (topic, payload) => {
            const msg = {
                version: comApiVersion,
                topic,
                channel: this.channelLabel,
                payload,
            };
            await Promise.all(this.channel.publish(topic, msg)).catch(err => {
                AlkLogger.warn(err);
            });
        };
        this.register = async (topic, listener) => {
            this.channel.register(topic, (action) => {
                Promise.all(this.channel.publish(topic, action)).catch(err => {
                    AlkLogger.warn(err);
                });
                listener(action);
            });
        };
        this.unregister = async (topic) => {
            return this.channel.remove(topic);
        };
        this.onConnection = async () => {
            await new Promise(resolve => {
                this.channel.onConnection(() => {
                    resolve(true);
                });
            });
        };
    }
    onDisconnection(cb) {
        this.channel.onDisconnection(cb);
    }
}
export class OpenfinChannelClient {
    constructor() {
        this.create = async (channelLabel, wait = false) => {
            this.channel = await fin.InterApplicationBus.Channel.connect(channelLabel, { wait });
            return this;
        };
        this.disconnect = async () => {
            await this.channel.disconnect();
        };
        this.dispatch = async (topic, payload) => {
            const msg = {
                version: comApiVersion,
                channel: this.channel.providerIdentity.channelName,
                topic,
                payload,
            };
            await this.channel.dispatch(topic, msg);
        };
        this.register = async (topic, listener) => {
            await this.channel.register(topic, listener);
        };
        this.unregister = async (topic) => {
            return this.channel.remove(topic);
        };
    }
    onDisconnection(cb) {
        this.channel.onDisconnection(cb);
    }
}
